<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Unit Conversion</h2>
      <v-card class="mt-4">
      <UnitConversion/>
  </v-card>
  </div>
</template>

<script>
import UnitConversion from '@/components/Utils/UnitConversion.vue'
  export default {
    components: {
      UnitConversion
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>